<template>
  <div class="md:pb-10 lg:pb-10 relative z-index1 px-2 filternone">
    <!-- <div class="absolute insights-bg z-index--1 md:block lg:block hidden">
      <img
        src="../../../../assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <div class="absolute insights-bg-mob  md:hidden lg:hidden block">
      <img
        src="../../../../assets/images/line/inst-news-bg-mob.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div> -->
    <div class="">
      <div class="lg:w-4/5 w-full lg:px-0 px-4 mx-auto md:pt-12 lg:pt-12 pt-6">
        <div class="flex justify-between items-center w-full">
          <div class="flex justify-between items-center w-full">
            <p
              class="title fsize36-16px-isg lg:font-normal md:font-normal font-bold"
            >
              Recommended Courses
            </p>
            <!-- <base-button
              outline
              type="primary"
              class="
                md:px-10
                lg:px-10
                px-6
                md:py-2
                lg:py-2
                py-1
                fs16700
                border-2
                mx-auto
              "
              @click="handleClick('e-all-categories')"
              >View more</base-button
            > -->
          </div>

          <!-- <div class="md:block lg:block hidden">
            <div class="flex text-black">
              <b-form-select
                v-model="selectedDis"
                :options="Disease"
                class="
                  mr-4
                  border-2 border-primary
                  text-base text-primary
                  font-medium
                "
              ></b-form-select>
              <b-form-select
                v-model="selectedSeg"
                :options="Segment"
                class="
                  mr-4
                  border-2 border-primary
                  text-base text-primary
                  font-medium
                "
              ></b-form-select>
              <b-form-select
                v-model="selectedUsers"
                :options="Users"
                class="
                  border-2 border-primary
                  text-base text-primary
                  font-medium
                "
              ></b-form-select>
            </div>
          </div> -->
        </div>
        <div class="md:pt-0 lg:pt-3 pt-0">
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 grid-rows-2 gap-x-8 md:gap-y-16 lg:gap-6"
          >
            <div
              class="md:mt-0 lg:mt-0 mt-6 mb-3 cursor-pointer rounded-lg shadow-xl bg-white"
              v-for="(item, index) in course"
              :key="'item -' + index"
              @click="courseDetails('e-course-detail', item)"
            >
              <div class="overflow-hidden hover-rad-tr relative">
                <img
                  :src="$imageURL + '/' + item.icone"
                  alt="NewsTitle"
                  class="rounded-t-lg h-52 w-full object-contain"
                />
                <a
                  class="cursor-pointer text-primary bookmark"
                  v-if="userData.role != 'admin' && userData.role != 'author'"
                >
                  <template v-if="whishlistCheck(item._id)">
                    <feather-icon
                      icon="HeartIcon"
                      @click.stop="removeWishlist(item)"
                      class="cursor-pointer text-primary bookmark"
                      :svgClasses="'wishlistActive'"
                    ></feather-icon>
                  </template>
                  <template v-else>
                    <feather-icon
                      icon="HeartIcon"
                      class="cursor-pointer text-primary bookmark"
                      @click.stop="getWishlist(item)"
                    />
                  </template>
                </a>
              </div>

              <div class="p-5">
                <div
                  class="md:mt-5 lg:mt-5 mt-2 flex justify-between items-center"
                >
                  <div class="flex">
                    <p class="text-xs clr777 font-normal">
                      {{ item.chapter.length }} chapters
                    </p>
                  </div>
                  <div class="flex">
                    <a
                      v-if="
                        userData.role != 'admin' && userData.role != 'author'
                      "
                      ><i
                        class="fa fa-shopping-cart"
                        @click="addToCart(item)"
                      ></i
                    ></a>
                  </div>
                </div>
                <p
                  class="md:mt-2 lg:mt-2 mt-2 text-black footertitle font-bold cursor-pointer fsize18-14px ellipsis-1 mxh65"
                >
                  {{ item.name }}
                </p>
                <p
                  class="md:mt-2 lg:mt-0 mt-2 font-normal cursor-pointer fsize16-14px ellipsis-2"
                >
                  {{ item.description }}
                </p>
                <!--  -->
                <div class="flex lg:flex-wrap" v-if="item.price < 1">
                  <p
                    class="text-black footertitle font-bold cursor-pointer fsize20-14px ellipsis-2 mxh65"
                  >
                    Free
                  </p>
                </div>
                <div class="flex mt-2 lg:flex-wrap" v-else>
                  <div
                    class="mt-2 lg:flex-wrap"
                    v-if="item.price != item.discountPrice"
                  >
                    <div class="flex items-center">
                      <p class="font-semibold fsize12 line-through clr777 mr-2">
                        &#8377; {{ item.price }}
                      </p>
                      <p class="font-semibold fsize16 text-black">
                        <template
                          v-if="
                            Object.keys(getUserByUserId).length !== 0 &&
                            Object.hasOwn(getUserByUserId, 'currentMembership')
                          "
                        >
                          &#8377;{{
                            (
                              item.discountPrice -
                              (getUserByUserId.currentMembership.discount /
                                100) *
                                item.discountPrice
                            ).toFixed(2)
                          }}
                        </template>
                        <template v-else>
                          &#8377;{{ item.discountPrice.toFixed(2) }}
                        </template>
                        <!-- Rs {{ item.discountPrice }} -->
                      </p>
                    </div>
                    <div class=" ">
                      <p class="font-semibold fsize14 text-primary">
                        <template
                          v-if="
                            Object.keys(getUserByUserId).length !== 0 &&
                            Object.hasOwn(getUserByUserId, 'currentMembership')
                          "
                        >
                          {{
                            (
                              ((item.price - item.discountPrice) / item.price) *
                              100
                            ).toFixed(2)
                          }}% Off <br />
                          <span class="text-success">
                            {{
                              getUserByUserId.currentMembership.discount.toFixed(
                                2
                              )
                            }}% off Additonal Membership Discount</span
                          >
                        </template>
                        <template v-else>
                          {{
                            (
                              ((item.price - item.discountPrice) / item.price) *
                              100
                            ).toFixed(2)
                          }}% Off
                        </template>
                        <!-- {{
                        (
                          ((item.price - item.discountPrice) / item.price) *
                          100
                        ).toFixed(2)
                      }}% off -->
                      </p>
                    </div>
                  </div>

                  <div class="flex items-center mt-2" v-else>
                    <p class="font-semibold text-lg text-black">
                      <!-- Rs {{ item.price }} -->
                    </p>

                    <p class="font-semibold fsize12 line-through clr777 mx-2">
                      <template
                        v-if="
                          Object.keys(getUserByUserId).length !== 0 &&
                          Object.hasOwn(getUserByUserId, 'currentMembership')
                        "
                      >
                        &#8377;{{ item.price.toFixed(2) }}
                      </template>
                    </p>
                    <p
                      v-if="
                        Object.keys(getUserByUserId).length !== 0 &&
                        Object.hasOwn(getUserByUserId, 'currentMembership')
                      "
                      class="font-semibold fsize16 text-black"
                    >
                      &#8377;{{
                        (
                          item.price -
                          (getUserByUserId.currentMembership.discount / 100) *
                            item.price
                        ).toFixed(2)
                      }}
                    </p>
                    <template v-else>
                      &#8377;{{ item.price.toFixed(2) }}
                    </template>

                    <p class="ml-2 font-semibold fsize14 text-primary">
                      <template
                        v-if="
                          Object.keys(getUserByUserId).length !== 0 &&
                          Object.hasOwn(getUserByUserId, 'currentMembership')
                        "
                      >
                        {{
                          getUserByUserId.currentMembership.discount.toFixed(2)
                        }}% off
                      </template>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex lg:mt-20 md:mt-20 mt-8 lg:mb-0 md:mb-0 mb-4">
            <base-button
              outline
              type="primary"
              class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2 mx-auto"
              @click="handleClick('e-courses')"
              >View more</base-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogItem from "../../../insights/blogs/components/BlogItem.vue";
// import pageMixin from "@/views/social/admin/pages/blog/mixins/pageMixin";
import { mapState } from "vuex";

export default {
  // mixins: [pageMixin],
  components: {
    BlogItem,
  },
  data() {
    return {
      selectedDis: null,
      selectedUsers: null,
      wishlistData: [],
      cartData: [],
      selectedSeg: null,
      Disease: [
        { value: null, text: "Disease" },
        { value: "a", text: "This is First option" },
        { value: "b", text: "Selected Option" },
        { value: "c", text: "This one is disabled" },
      ],
      Segment: [
        { value: null, text: "Segment" },
        { value: "d", text: "This is First option" },
        { value: "e", text: "Selected Option" },
        { value: "f", text: "This one is disabled" },
      ],
      Users: [
        { value: null, text: "Users" },
        { value: "g", text: "This is First option" },
        { value: "h", text: "Selected Option" },
        { value: "i", text: "This one is disabled" },
      ],
      news: [
        {
          image: require("@/assets/images/child cancer.jpg"),
        },
        {
          image: require("@/assets/images/news2.jpg"),
        },
        {
          image: require("@/assets/images/news3.jpg"),
        },
        {
          image: require("@/assets/images/news4.jpg"),
        },
        {
          image: require("@/assets/images/news5.jpg"),
        },
        {
          image: require("@/assets/images/abtus.jpg"),
        },
        {
          image: require("@/assets/images/hcp-grid2.jpg"),
        },
        {
          image: require("@/assets/images/img8.jpg"),
        },
      ],
      course: [],
    };
  },
  computed: {
    // ...mapState("cms", {
    //   pages: "pages",
    //   mostread: "mostread",
    // }),
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("auth", ["userData"]),
    ...mapState("student", ["get_singlestudent"]),
  },
  methods: {
    async handleClick(name) {
      this.$router.push({ name: name });
      await this.$store.commit("eLearning/SET_SEARCH", "");
      await this.$store.commit("eLearning/selectedCat", []);
      // this.toggleNavbar();
    },
    async getCourses() {
      try {
        const { data } = await this.$store.dispatch("eLearning/getCourses", {
          limit: 8,
        });
        this.course = data;
      } catch (err) {
        console.log(err.response);
        if (err.response.data.code == 401) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }

      // console.log(data);
    },
    courseDetails(name, data) {
      this.$store.commit("eLearning/selectedCourseHome", data);
      this.$router.push({ name: name });
      //console.log(data);
    },
    whishlistCheck(id) {
      if (this.get_singlestudent && this.get_singlestudent.wishlist) {
        let course = this.get_singlestudent.wishlist.map((e) => e);
        let wishList = course.map((e) => e.course[0]._id);
        if (
          Object.keys(this.get_singlestudent).length > 0 &&
          wishList.includes(id)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    async getWishlist(items) {
      const token = sessionStorage.getItem("token");
      if (token == "" || token == undefined || token == null) {
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return this.$router.push({ name: "signin" });
      }
      try {
        const { data } = await this.$store.dispatch("wishlist/AddWishlist", {
          course: items._id,
          type: "Course",
        });
        this.$notify({
          title: "Added",
          message: "Course add to wishlist!!",
          type: "success",
          duration: "2000",
        });
        await this.$store.dispatch(
          "student/getsinglestudent",
          this.userData.student._id
        );
        this.get_singlestudent.wishlist.forEach((ele) => {
          this.wishlistData.push(ele.course[0]._id);
        });
        this.whishlistCheck(items._id);
        // console.log(data);
      } catch (e) {
        // console.log(e.response.status == 500);
        if (e.response.status == 500) {
          this.$notify({
            title: "Already Exist",
            message: "Course already in wishlist!!",
            type: "info",
            duration: "2000",
          });
        }
      }
    },
    async removeWishlist(item) {
      // console.log(item._id);
      if (item._id.length != 0) {
        const index = this.wishlistData.indexOf(item._id);
        // console.log("this.wishlistData", this.wishlistData);
        // console.log(index);
        if (index > -1) {
          this.wishlistData.splice(index, 1);
          // console.log(this.wishlistData);
        }
        // this.$swal("Removed!", "Item has been removed.", "success");

        let checkArry = this.get_singlestudent.wishlist.filter((e) => {
          if (e.course.length > 0) {
            return e.course[0]._id == item._id;
          } else {
            return false;
          }
        });
        // console.log(this.get_singlestudent.wishlist)

        await this.$store.dispatch("wishlist/removeWishlist", {
          _id: checkArry[0]._id,
          wishlist: checkArry[0]._id,
          student: this.userData.student._id,
        });
        this.$swal.fire({
          title: "Removed!",
          text: "Item has been removed.",
          icon: "success",
          confirmButtonColor: "#830c81",
        });
        await this.$store.dispatch(
          "student/getsinglestudent",
          this.userData.student._id
        );
      }
      // this.getAllStudents();
    },
    async addToCart(item) {
      //  let flag = 0;
      //  this.cartData.filter((data) => {
      //    if(data == item._id){
      //      flag = 1;
      //    }
      //  });
      try {
        const data = await this.$store.dispatch("cart/AddCart", {
          type: "Course",
          course: item._id,
        });
        // console.log(data);
        if (data.code == 200) {
          this.$store.commit("auth/userCart", data.data);
          this.$swal.fire({
            title: "Added To Cart!!!",

            text: "Course added to your learning plan!",

            icon: "success",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.$router.push({ name: "e-home" });
          // this.cartData.push(item._id);
        }
      } catch (err) {
        if (err.response.data.code == 401) {
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.$router.push({ name: "signin" });
        }
        this.$swal.fire({
          title: "Already Exist!!!",

          text: "Item is already in Cart!",

          icon: "warning",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 2000,
        });
        this.$router.push({ name: "e-cart" });
      }
    },
  },
  async mounted() {
    if (Object.keys(this.user).length != 0) {
      let payload = {
        userId: this.user._id,
      };
      const getUser = await this.$store.dispatch(
        "auth/getUserByUserId",
        payload
      );
      if (this.userData.student) {
        await this.$store.dispatch(
          "student/getsinglestudent",
          this.userData.student._id
        );
        this.get_singlestudent.wishlist.forEach((ele) => {
          // console.log(ele)
          if (Object(ele.course[0]).hasOwnProperty("_id")) {
            this.wishlistData.push(ele.course[0]._id);
          }
        });
      }
    }
    this.getCourses();
  },
};
</script>
<style>
.bookmark {
  position: absolute !important;
  top: 5px;
  right: 5px;
}

.wishlistActive {
  fill: #4f0a4b;
  stroke: #4f0a4b;
}
</style>
